import React from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import { utils, read } from 'xlsx';
import { useTranslation } from 'react-i18next';

/** 엑셀 업로드 */

const ExcelImport = ({ setImportedExcel, el, auth }) => {
  const { t } = useTranslation();
  const onImportExcel = (file) => {
    console.log(file);
    // 업로드한 파일객체 받기
    const { files } = file.target;
    // FileReader를 통해 파일 읽기
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      try {
        const { result } = event.target;
        // 2진법류 방식으로 전체 엑셀표 대상 읽기
        const workbook = read(result, { type: 'binary' });
        // 메모리 저장
        let originalData = [];
        // let copyData = []; // 컨버팅 후 담는 배열

        // 데이터 (표) 읽기
        for (const sheet in workbook.Sheets) {
          if (Object.prototype.hasOwnProperty.call(workbook.Sheets, sheet)) {
            // sheet_to_json 방법으로 엑셀을 json 데이터로 변환
            // let uploadedExcel = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {defval: null});
            originalData = originalData.concat(
              utils.sheet_to_json(workbook.Sheets[sheet], { defval: '' }),
            );
            // let copyData = originalData.map((v, i) => console.log(Object.keys(v), "::: ", i));

            /** 컬럼명 converting 하기 */
            originalData.forEach((item) => {
              //   // console.log(item);
              //   // console.log(item["사건 ID"]);
              //   // console.log(item["template"]);
              //   // console.log(item["말풍선 위치"]);
              const arr = Object.values(item);
              // console.log(arr);
              item.scene_id = arr[0]; // 사건 id
              item.template = arr[1]; // 템플릿
              item.speaker = arr[2]; // 화자
              item.script_data = arr[3]; // 데이터
              item.target_scene_id = arr[4]; // 사건 이동
              item.requisite = arr[5]; // 조건
              item.character_expression = arr[6]; // 캐릭터 표현
              item.emoticon_expression = arr[7]; // 이모티콘 표현

              item.bubble_size = arr[8]; // 말풍선 크기
              item.bubble_pos = arr[9]; // 말풍선 위치

              item.control = arr[10]; // 제어
              item.voice = arr[11]; // 음성
              item.sound_effect = arr[12]; // 효과음
              item.in_effect = arr[13]; // 등장효과
              item.out_effect = arr[14]; // 퇴장효과

              item.autoplay_row = arr[15]; // 자동진행
              item.dev_comment = arr[16]; // 메모
            });

            // console.log('converting >>>>  ', originalData);
            // console.log("key", Object.values(originalData[0]));
            // console.log("key", Object.values(originalData));

            break;
          }
        }

        // 최종 json 데이터
        // console.log(originalData, 'original');
        setImportedExcel(originalData);

        message.success(t('editorContents.header.uploadExcelMessage'), 1);
      } catch (e) {
        console.log(e);
      }
    };
    // binary 방식으로 열림
    fileReader.readAsBinaryString(files[0]);
  };

  return (
    <>
      <Filebox disabled={auth}>
        <label htmlFor='exFile'>{t('editorContents.header.uploadExcel')}</label>
        <input
          id='exFile'
          type='file'
          accept='.xlsx, .xls'
          onChange={onImportExcel}
          disabled={auth}
        />
      </Filebox>
    </>
  );
};
export default ExcelImport;

const Filebox = styled.div`
  display: inline-block;
  padding: 0.6rem 1.2rem;
  background-color: ${(props) => props.theme.colors.tableInButton};
  cursor: ${(props) => (props.disabled === true ? 'not-allowed' : 'pointer')};
  box-shadow: 2px 1.5px 2px 0.2px rgb(0 0 0 / 15%);
  margin-left: 0.8rem;
  border-radius: 0.3rem;
  color: ${(props) => props.theme.colors.blueText};
  /* color: ${(props) => props.disabled === true && `#aaaaaa`}; */
  label {
    font-weight: 700;
    cursor: ${(props) => (props.disabled === true ? 'not-allowed' : 'pointer')};
  }
  input[type='file'] {
    cursor: pointer;
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    // margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;
